import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Dashboard } from '../../interface/dashboard';
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/map";

@Injectable()
export class DashboardService {
  dashboardAction = new Subject();
  dashboardName: String = "";

  constructor(private httpClient: HttpClient) { }

  //Create Private Dashboard
  create(form): Observable<any> {
    let body = form;
    return this.httpClient.post('private-dashboard', body);
  }

  //List of all Private Dashboard
  list(): Observable<Dashboard[]> {
    return this.httpClient.get<Dashboard[]>('private-dashboard');
  }

  // Delete Dahsboard
  delete(dashboardId): Observable<any> {
    return this.httpClient.delete('private-dashboard/' + dashboardId);
  }

  getAction(): Observable<any> {
    return this.dashboardAction.asObservable();
  }

  sendAction(action, data) {
    return this.dashboardAction.next({ action: action, data: data });
  }

  update(dashboardForm): Observable<any> {
    return this.httpClient.patch('private-dashboard', dashboardForm);
  }

  siteCount(filter = ""): Observable<any> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<any>("site?count=1" + filter);
  }

  deviceCount(filter = ""): Observable<any> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<any>("device?count=1" + filter);
  }

  userCount(filter = ""): Observable<any> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get<any>("customer?count=1" + filter);
  }

  downloadReport(url): Observable<any> {
    // const options = {headers: "", params: "",responseType :"text"};
    return this.httpClient.get(url,{responseType: 'blob'})
    .catch( (err)=>{
      throw err;
    });
  }

  requestMail(url,body){
    return this.httpClient.post(url,body)
    .catch((err)=>{
      throw err;
    });
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/dashboard/dashboard.service.ts